// 特殊機能表示状態を保持する画面
export const keepSpecialFunctionList = [
  'individualEcuTable',
  'individualSelect',
  'individualDiagCode',
  'individualCancelCode',
  'individualDataMonitor',
  'individualVehicleControlHistory',
  'individualActiveTest',
  'individualWorkSupport',
  'individualCustomize',
  'spDiagCode',
  'spCancelCode',
  'spDataMonitor',
  'spVehicleControlHistory',
];